import { render, staticRenderFns } from "./LicitacaoFornecedorPropostaItemAnexo.vue?vue&type=template&id=3ed0e010"
import script from "./LicitacaoFornecedorPropostaItemAnexo.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorPropostaItemAnexo.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorPropostaItemAnexo.vue?vue&type=style&index=0&id=3ed0e010&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports